let productList1 = [
    {
        "id":"2e36e6a6-21f5-46af-a16f-9b9d57fc9dcf",
        "name":"Handcrafted Fresh Towels",
        "price":"$223.00",
        "shortDescription":"Officiis ab optio consequuntur quidem et excepturi debitis.",
        "description":"Dolorem omnis qui omnis. Dolores occaecati autem aliquam nihil in non repellendus. Asperiores vel qui voluptatem qui aliquid. Vel sunt eos porro qui sed aliquam autem amet. Ea iure fugit animi est qui neque.",
        "image":"https://picsum.photos/id/1/500/500/",
        "category":"Music"
    },
    {
        "id":"30f4b1e9-4db7-4e01-8f95-f12d023e24df",
        "name":"Incredible Rubber Mouse",
        "price":"$125.00",
        "shortDescription":"Quia facere odit voluptate.",
        "description":"Necessitatibus minus repellendus quo aut voluptatem et. Et earum non sequi sed aut nulla. Sit velit ratione totam nemo qui ipsam delectus aut aut. Expedita voluptas aut dolores est fuga.",
        "image":"https://picsum.photos/id/10/500/500/",
        "category":"Garden"
    },
    {
        "id":"25164bd3-552c-402f-9b56-94306726e812",
        "name":"Handcrafted Frozen Chair",
        "price":"$133.00",
        "shortDescription":"Ex magni rerum voluptas.",
        "description":"Aliquid animi et iste eos aperiam necessitatibus est. Eum consectetur velit veritatis sequi praesentium voluptatem eum. Vel est sapiente quae. Non quas nam id adipisci hic voluptatem et. Amet nam adipisci consequatur quo molestias doloremque molestias.",
        "image":"https://picsum.photos/id/100/500/500/",
        "category":"Health"
    },
    {
        "id":"1009923d-e700-4a56-affc-6d39360547e8",
        "name":"Gorgeous Frozen Salad",
        "price":"$251.00",
        "shortDescription":"Eaque velit eum ut ad.",
        "description":"Placeat in magni recusandae velit dignissimos reprehenderit ea. Harum cumque alias enim quia consequatur et tenetur.",
        "image":"https://picsum.photos/id/1000/500/500/",
        "category":"Kids"
    },
    {
        "id":"985e78f7-371f-4d8d-9482-f35ca105403e",
        "name":"Handcrafted Cotton Ball",
        "price":"$267.00",
        "shortDescription":"Est voluptates est ex fuga et itaque.",
        "description":"Qui iusto dicta enim pariatur. Eveniet minus reprehenderit rerum occaecati quis sed rem sunt saepe. Alias sapiente officiis in. Quia necessitatibus aspernatur aut magni quasi. Est in enim mollitia est sunt officiis modi et sit. Nam necessitatibus veritatis repellendus deleniti maiores dignissimos.",
        "image":"https://picsum.photos/id/1001/500/500/",
        "category":"Movies"
    },
    {
        "id":"a2062663-f317-4db3-987f-9a2bc152549f",
        "name":"Unbranded Metal Pants",
        "price":"$35.00",
        "shortDescription":"Ut est quisquam totam dolore mollitia quo.",
        "description":"Qui aperiam inventore et sint sequi dignissimos nesciunt commodi. Odio quos cumque qui. Dolores voluptates autem amet numquam et et aspernatur non laudantium. Reprehenderit autem ipsam sapiente dolores tempore. Quaerat et maiores id ut ut. Tempore accusantium explicabo.",
        "image":"https://picsum.photos/id/1002/500/500/",
        "category":"Books"
    },
    {
        "id":"e70f5324-b45b-44da-b08d-ffe58c40d99e",
        "name":"Handmade Metal Hat",
        "price":"$138.00",
        "shortDescription":"Sequi sequi commodi amet.",
        "description":"Magni fuga perferendis praesentium ipsam sit corporis error fugiat. Aliquam quia sint. Voluptatibus molestiae et. Qui error ducimus ut reiciendis accusantium magnam et delectus sapiente. Repellat consequuntur ipsa cumque dolorum dicta velit quidem.",
        "image":"https://picsum.photos/id/1003/500/500/",
        "category":"Kids"
    },
    {
        "id":"513a987d-706f-4c86-8288-d1c2ca3d1f73",
        "name":"Handmade Granite Car",
        "price":"$312.00",
        "shortDescription":"Repudiandae voluptas facere aut provident cum accusantium qui laudantium ipsa.",
        "description":"Natus reprehenderit accusantium sed atque. Cupiditate id dignissimos saepe repudiandae tempora nostrum labore cupiditate fugiat. Officia labore quam repudiandae eum deleniti magni qui iste rerum. Enim nihil aut. Dicta vitae provident nihil itaque quod culpa rerum. Est perferendis non sed error ex excepturi sapiente tempore.",
        "image":"https://picsum.photos/id/1004/500/500/",
        "category":"Clothing"
    },
    {
        "id":"23f167c0-c91d-44ef-83c5-3209d5d8252e",
        "name":"Incredible Concrete Keyboard",
        "price":"$16.00",
        "shortDescription":"Sunt et omnis.",
        "description":"Alias fuga repellendus quis est in tempora dolor autem molestiae. Debitis architecto nostrum aperiam porro inventore adipisci repellendus. Qui voluptatem consequuntur.",
        "image":"https://picsum.photos/id/1005/500/500/",
        "category":"Clothing"
    },
    {
        "id":"8ce017b5-dad5-4e43-a92f-7d61f48128d8",
        "name":"Unbranded Granite Gloves",
        "price":"$98.00",
        "shortDescription":"Sit qui tempora et incidunt ab.",
        "description":"Magnam facere pariatur facilis ut optio. Quae et ipsa ullam nihil deleniti sed quia. Repellendus nesciunt occaecati enim voluptas incidunt vel illo sit.",
        "image":"https://picsum.photos/id/1006/500/500/",
        "category":"Home"
    },
    {
        "id":"2e03707e-0eaa-4eb4-a023-f240c334bb13",
        "name":"Licensed Rubber Tuna",
        "price":"$149.00",
        "shortDescription":"Qui debitis aperiam optio.",
        "description":"Neque consequatur omnis qui ipsa cumque. Molestiae sint nobis necessitatibus commodi natus distinctio corporis. Ut dolores et non ex porro. Expedita alias facilis eligendi.",
        "image":"https://picsum.photos/id/1008/500/500/",
        "category":"Music"
    },
    {
        "id":"ec3719df-3f9e-4d39-b64b-2014978b0286",
        "name":"Intelligent Granite Car",
        "price":"$327.00",
        "shortDescription":"Laboriosam rem at quisquam.",
        "description":"Voluptas doloremque ut aliquid corrupti sed et. Placeat quis est et distinctio minima consequatur. Dolore omnis ad soluta et labore. Pariatur quas accusantium cupiditate laboriosam aspernatur distinctio quas qui exercitationem.",
        "image":"https://picsum.photos/id/1009/500/500/",
        "category":"Garden"
    },
    {
        "id":"708c29ac-3ccd-4a32-b2e7-5521c9334949",
        "name":"Small Metal Tuna",
        "price":"$133.00",
        "shortDescription":"Optio rerum nostrum laboriosam ullam aut vero sapiente minus.",
        "description":"Vitae numquam inventore consequatur vero dignissimos doloribus atque voluptatem. Sunt qui harum rem ab natus ex.",
        "image":"https://picsum.photos/id/101/500/500/",
        "category":"Industrial"
    },
    {
        "id":"e962d5de-bde8-4ce9-83df-8f355733228c",
        "name":"Handcrafted Metal Hat",
        "price":"$339.00",
        "shortDescription":"Ut nam magni.",
        "description":"Est non laborum. Enim natus dolorem quas. Officia ratione in vitae. Omnis ipsam dolor aut. Et architecto odio quia rerum aut et quae enim. Voluptatem qui molestiae.",
        "image":"https://picsum.photos/id/1010/500/500/",
        "category":"Baby"
    },
    {
        "id":"0f86a9ae-2c97-4c3c-b59d-69d7c0025aa6",
        "name":"Awesome Rubber Gloves",
        "price":"$327.00",
        "shortDescription":"Molestiae est eum id quis doloremque inventore.",
        "description":"Unde itaque ipsa sit officia suscipit repellendus ea ut enim. Iste quam perspiciatis facilis ipsum accusamus facere quo harum atque. Itaque sapiente voluptatem ea et est cumque atque. Sed perferendis unde totam illo labore. Repellat aut soluta et ut porro.",
        "image":"https://picsum.photos/id/1011/500/500/",
        "category":"Automotive"
    },
    {
        "id":"fa0149f8-332b-44e4-9d0c-2ea0c06cb0e5",
        "name":"Tasty Fresh Computer",
        "price":"$364.00",
        "shortDescription":"Optio tempore blanditiis eum nisi nihil.",
        "description":"Et qui saepe omnis voluptas illo corrupti. Adipisci dolorum et est ea quia illum quia.",
        "image":"https://picsum.photos/id/1012/500/500/",
        "category":"Games"
    },
    {
        "id":"4c9ff242-bebf-4010-a58c-d1ae78bbb10c",
        "name":"Rustic Wooden Car",
        "price":"$41.00",
        "shortDescription":"Non alias harum possimus.",
        "description":"Deleniti atque corrupti exercitationem eos dolor necessitatibus. Impedit quis consequatur aut dolores aspernatur laboriosam velit error. Esse quod possimus sunt earum eveniet numquam porro. Fugit aliquid repudiandae voluptatem omnis.",
        "image":"https://picsum.photos/id/1013/500/500/",
        "category":"Books"
    },
    {
        "id":"5f803329-eac7-438e-94d3-32b578e7f4ff",
        "name":"Unbranded Wooden Table",
        "price":"$33.00",
        "shortDescription":"Dolorem non nulla.",
        "description":"Est eos aliquam quia. Nesciunt aut magni molestiae.",
        "image":"https://picsum.photos/id/1014/500/500/",
        "category":"Baby"
    },
    {
        "id":"6287da97-a999-4850-8c43-a5d353305cad",
        "name":"Generic Frozen Shirt",
        "price":"$303.00",
        "shortDescription":"Sunt et id fugiat vel placeat sequi vel.",
        "description":"Magnam corrupti tempora molestiae consequatur. Assumenda illum quia rem quasi ut cumque commodi ducimus.",
        "image":"https://picsum.photos/id/1015/500/500/",
        "category":"Books"
    },
    {
        "id":"d6734fca-1409-4ff7-b1b0-cfd24b301c65",
        "name":"Small Metal Salad",
        "price":"$373.00",
        "shortDescription":"Est autem sunt deserunt cupiditate.",
        "description":"Magni modi alias blanditiis dolores repellendus in. Qui atque voluptas nulla distinctio iure eaque beatae ut. Possimus porro numquam iusto possimus expedita doloremque quae porro qui.",
        "image":"https://picsum.photos/id/1016/500/500/",
        "category":"Games"
    },
    {
        "id":"ef59fb24-b7c6-460d-b9b0-4893f8db34e4",
        "name":"Intelligent Granite Sausages",
        "price":"$104.00",
        "shortDescription":"A rem non quibusdam dolore rerum.",
        "description":"Voluptate quia quasi velit. Reiciendis eius sit nostrum quo. Similique et ea illo sint quisquam quasi repellat facere soluta. Possimus unde ullam. Dolor sit assumenda aut libero.",
        "image":"https://picsum.photos/id/1018/500/500/",
        "category":"Books"
    },
    {
        "id":"7e9e80a4-59e3-4063-95f4-35ed72ce523d",
        "name":"Handmade Metal Salad",
        "price":"$215.00",
        "shortDescription":"Consequatur a aut et qui quidem.",
        "description":"Odit non reprehenderit. Blanditiis pariatur voluptatem rerum ex. Debitis tempora non sequi commodi. Facilis consequuntur nisi harum qui rerum. Eius qui quo aspernatur dolor modi et. Et reiciendis provident harum voluptas alias eos at aut.",
        "image":"https://picsum.photos/id/1019/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"737a86da-81d3-475d-90ee-c78513f24661",
        "name":"Practical Plastic Fish",
        "price":"$96.00",
        "shortDescription":"Ullam reiciendis sit eligendi rerum sunt voluptatem qui.",
        "description":"Ad nam beatae et iusto itaque deserunt saepe nulla. Est iure unde maxime et qui beatae in optio in.",
        "image":"https://picsum.photos/id/102/500/500/",
        "category":"Music"
    },
    {
        "id":"203f8850-2a76-4a15-a103-887b116e5a74",
        "name":"Sleek Soft Salad",
        "price":"$75.00",
        "shortDescription":"Explicabo odio necessitatibus et repudiandae et dolores.",
        "description":"Dignissimos fugit quibusdam cum alias consequatur voluptas. Incidunt beatae sunt necessitatibus deserunt iure ab facilis dolor. Praesentium rem sed velit accusamus temporibus voluptatem. Consequatur et temporibus possimus nihil hic. Earum animi adipisci asperiores saepe beatae molestiae sed.",
        "image":"https://picsum.photos/id/1020/500/500/",
        "category":"Toys"
    },
    {
        "id":"87ea35ce-ad04-4e74-a0b6-d2fc0209d37a",
        "name":"Incredible Plastic Keyboard",
        "price":"$102.00",
        "shortDescription":"Possimus qui minima molestias ipsam omnis similique deleniti ullam.",
        "description":"Quo qui impedit a ut facilis. Porro iste quae ut et. Amet molestias vel velit. Itaque sint aliquid.",
        "image":"https://picsum.photos/id/1021/500/500/",
        "category":"Automotive"
    },
    {
        "id":"a54b043b-6975-4936-ab03-01c7dccaa283",
        "name":"Licensed Cotton Bacon",
        "price":"$275.00",
        "shortDescription":"Ipsam assumenda dolore iusto velit.",
        "description":"Exercitationem ut dolores iusto a quis maiores. Quae et tempore quo nostrum aliquam reiciendis fugit.",
        "image":"https://picsum.photos/id/1022/500/500/",
        "category":"Garden"
    },
    {
        "id":"b5094948-7370-48c6-a3a6-0ba5ed42c268",
        "name":"Intelligent Steel Pants",
        "price":"$341.00",
        "shortDescription":"Qui sequi consequuntur nemo officia facilis eaque fugiat.",
        "description":"Corporis illum illo est quae deleniti deserunt. Quis enim sed rerum eum soluta alias velit. Dolor labore recusandae atque exercitationem ut repellendus. Temporibus praesentium quisquam eos animi et. Eos qui dolor a dolore et ut aut ut. Sapiente id praesentium nesciunt molestias sit enim in ab ut.",
        "image":"https://picsum.photos/id/1023/500/500/",
        "category":"Electronics"
    },
    {
        "id":"5d47529e-2fb8-4ab9-9af9-cc5f69662d29",
        "name":"Incredible Plastic Hat",
        "price":"$56.00",
        "shortDescription":"Ratione reiciendis doloremque sit aut labore accusamus neque at dolores.",
        "description":"Porro eum voluptatem repellendus omnis sapiente in qui dolor. Ut et aliquam autem. Aliquid consectetur totam corrupti. Officiis sed ipsa sapiente voluptatibus architecto ipsam sed consectetur et. Quia omnis ea atque quia repudiandae fugiat similique ullam. Earum et exercitationem distinctio voluptate mollitia explicabo mollitia.",
        "image":"https://picsum.photos/id/1024/500/500/",
        "category":"Games"
    },
    {
        "id":"988c62d2-24ab-42f7-b846-9d6c8b645afb",
        "name":"Practical Metal Keyboard",
        "price":"$319.00",
        "shortDescription":"Quae cumque libero.",
        "description":"Neque placeat qui accusamus dolorum. Unde aspernatur ut omnis ea dolor commodi esse. Quos sint vitae aut fugit pariatur eaque quia.",
        "image":"https://picsum.photos/id/1025/500/500/",
        "category":"Kids"
    },
    {
        "id":"92247f6f-564d-461c-9c74-e4682908c709",
        "name":"Awesome Wooden Towels",
        "price":"$213.00",
        "shortDescription":"Quia aperiam quos nam consectetur perferendis voluptatem tempore.",
        "description":"Quae consequatur quo et repellat facere fuga. Omnis a magnam nihil maxime iusto et. Ratione dolorum vel.",
        "image":"https://picsum.photos/id/1026/500/500/",
        "category":"Music"
    },
    {
        "id":"2c754180-a8fc-4866-b298-4b3eb4c23da6",
        "name":"Generic Rubber Sausages",
        "price":"$373.00",
        "shortDescription":"Ipsum omnis quidem et nulla ratione.",
        "description":"Id voluptatem eum tempore voluptate. Cumque ipsa dolor id eius repellat ut. Natus aliquam ea consequatur officia placeat est error.",
        "image":"https://picsum.photos/id/1027/500/500/",
        "category":"Electronics"
    },
    {
        "id":"1ec6efaf-8659-41bc-8e3d-eff91a26aed8",
        "name":"Refined Concrete Gloves",
        "price":"$116.00",
        "shortDescription":"Earum dolorem placeat sequi corporis officiis ea voluptas aut.",
        "description":"Ut repudiandae qui eligendi qui. Facilis eos molestias eius. Debitis fuga est fugit illum. Aut culpa enim officiis vero quia aliquid pariatur eum.",
        "image":"https://picsum.photos/id/1028/500/500/",
        "category":"Games"
    },
    {
        "id":"20494e02-6698-49dd-9f0d-b5d0b8f918f2",
        "name":"Refined Plastic Pizza",
        "price":"$112.00",
        "shortDescription":"Nostrum aut vel temporibus dolorem.",
        "description":"Recusandae consequatur corporis. Facere error eum perspiciatis.",
        "image":"https://picsum.photos/id/1029/500/500/",
        "category":"Shoes"
    }
]

let productList2 = [
    {
        "id":"fe124bb6-3fd9-4cf4-a3db-64c1cd88fdbe",
        "name":"Generic Steel Shoes",
        "price":"$64.00",
        "shortDescription":"Iusto dolores impedit.",
        "description":"Fugit nobis adipisci voluptatem ipsam voluptas omnis. Similique dignissimos eum facere nam. Corrupti incidunt culpa quia omnis omnis dolore est ab quo. Voluptatem eligendi quidem. Voluptatum et ut vero ut modi tempore consequatur nemo exercitationem. Consequuntur minima animi dicta voluptatem dolorem labore placeat recusandae.",
        "image":"https://picsum.photos/id/103/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"a87b4b8e-1b44-427e-85d4-27eca16bbd21",
        "name":"Gorgeous Plastic Mouse",
        "price":"$369.00",
        "shortDescription":"Facere omnis voluptate qui magni.",
        "description":"Deleniti nobis perferendis cupiditate. Consequuntur cumque suscipit quod rem nemo voluptas aut totam. Perspiciatis beatae alias beatae perspiciatis laudantium quia voluptas omnis. Officiis voluptatem nisi ratione eum ab aut facilis. Neque velit magnam quasi qui laboriosam. Sit velit nam fugiat omnis itaque facere.",
        "image":"https://picsum.photos/id/1031/500/500/",
        "category":"Outdoors"
    },
    {
        "id":"45354804-5535-4920-b9dc-d978c436b507",
        "name":"Tasty Frozen Bacon",
        "price":"$174.00",
        "shortDescription":"Quos nisi non sint veritatis molestias.",
        "description":"Natus quia repudiandae molestiae dignissimos qui. Itaque a eum enim soluta harum est et. Ullam occaecati nobis ex pariatur vitae. Veniam deserunt dolorem qui blanditiis porro temporibus. Dignissimos ex rerum minima.",
        "image":"https://picsum.photos/id/1032/500/500/",
        "category":"Music"
    },
    {
        "id":"4d31ff8a-530a-425a-846c-bce2355c6a04",
        "name":"Small Metal Car",
        "price":"$364.00",
        "shortDescription":"Natus cupiditate tempore facilis aliquam.",
        "description":"Impedit illo sit labore rerum. Culpa reiciendis itaque et maxime occaecati aut repellendus eveniet. Voluptatem error laudantium cum tempore dolor. At ab reprehenderit et temporibus natus aliquam. Autem animi eligendi facilis asperiores et qui dolores quibusdam molestias. Ut laudantium sed et sint aliquid commodi iste sed.",
        "image":"https://picsum.photos/id/1033/500/500/",
        "category":"Electronics"
    },
    {
        "id":"166f4024-6c59-4b27-9f58-245688fe7be6",
        "name":"Incredible Fresh Salad",
        "price":"$351.00",
        "shortDescription":"Similique rerum accusantium et et.",
        "description":"Repudiandae officia quod ipsam ut aut. Labore dolor maiores neque aspernatur quis voluptas. Dolorem odit quisquam aut est. Laborum aut sit recusandae veritatis porro delectus est sint non. Nesciunt enim et tenetur deleniti deserunt et est voluptatem ut. Sed quas error.",
        "image":"https://picsum.photos/id/1035/500/500/",
        "category":"Grocery"
    },
    {
        "id":"1913da5d-82a7-4b71-8e91-a6940d27594c",
        "name":"Practical Rubber Sausages",
        "price":"$367.00",
        "shortDescription":"Qui culpa blanditiis unde dolorem perspiciatis excepturi saepe.",
        "description":"Sed aut explicabo quae praesentium ut nulla et voluptas. Quidem quia quas aut. Dolorum quia aperiam dolores qui incidunt ut culpa voluptatem aliquam.",
        "image":"https://picsum.photos/id/1036/500/500/",
        "category":"Health"
    },
    {
        "id":"680a23f3-708d-4bf2-8fec-4a479b55e5de",
        "name":"Intelligent Cotton Salad",
        "price":"$223.00",
        "shortDescription":"Recusandae ab enim culpa.",
        "description":"Quod commodi quibusdam incidunt natus debitis qui asperiores. Vel quia sit in quos fuga consectetur autem. Debitis repudiandae ut autem sint. Sequi animi omnis non nulla ut fugiat. Similique qui natus sit ipsum sed asperiores necessitatibus eius. Autem voluptatem numquam ducimus ipsam.",
        "image":"https://picsum.photos/id/1037/500/500/",
        "category":"Electronics"
    },
    {
        "id":"4c0126d3-ab06-4570-8c5a-3df5fd08178d",
        "name":"Incredible Cotton Pants",
        "price":"$353.00",
        "shortDescription":"Aut harum quis et ut.",
        "description":"Corporis provident eaque. Ut totam at. Corporis voluptatem modi omnis in. At saepe sit quis ea eaque at quasi vitae.",
        "image":"https://picsum.photos/id/1038/500/500/",
        "category":"Home"
    },
    {
        "id":"70229b44-7ea6-4f73-9a3b-e3d3c09a82bd",
        "name":"Rustic Rubber Salad",
        "price":"$326.00",
        "shortDescription":"Aut id aspernatur.",
        "description":"Incidunt ut quam. In mollitia velit animi. Omnis quaerat deserunt est dolorem. Perspiciatis sapiente et quia. Repudiandae aut aspernatur laboriosam ut non.",
        "image":"https://picsum.photos/id/1039/500/500/",
        "category":"Books"
    },
    {
        "id":"290bac8b-2c02-4ccf-a264-637dc90ec4a8",
        "name":"Fantastic Plastic Bike",
        "price":"$84.00",
        "shortDescription":"Accusantium asperiores velit quasi sed nemo in.",
        "description":"Nobis quia ex harum nobis. Quo accusamus corporis ut temporibus repellendus quaerat.",
        "image":"https://picsum.photos/id/104/500/500/",
        "category":"Outdoors"
    },
    {
        "id":"37d55f0a-f1ed-478f-bcc1-ff77f64ad676",
        "name":"Unbranded Fresh Cheese",
        "price":"$395.00",
        "shortDescription":"Rerum error qui sed consequatur consequatur et non.",
        "description":"Ea adipisci non. Vero quia nulla aut et. Voluptatem quia est id ipsum et dolorem rerum et.",
        "image":"https://picsum.photos/id/1040/500/500/",
        "category":"Computers"
    },
    {
        "id":"3783232f-4514-4b62-8bca-a7988c1b03b9",
        "name":"Unbranded Concrete Tuna",
        "price":"$207.00",
        "shortDescription":"Laboriosam porro nesciunt eligendi debitis.",
        "description":"Possimus excepturi sunt magni vero ducimus et officia officiis. Sequi vel deserunt. Vitae aut perspiciatis.",
        "image":"https://picsum.photos/id/1041/500/500/",
        "category":"Music"
    },
    {
        "id":"be9162f5-4a06-4d7e-b75f-892616ca3864",
        "name":"Tasty Metal Table",
        "price":"$227.00",
        "shortDescription":"Harum est ducimus inventore aliquam nam quo.",
        "description":"Facere autem eveniet assumenda quasi qui vitae rem. Rerum quod culpa magnam. Officia ipsa aperiam velit qui voluptatem voluptas.",
        "image":"https://picsum.photos/id/1042/500/500/",
        "category":"Industrial"
    },
    {
        "id":"97a06335-fd2e-4ebd-b212-1e31e482f0bd",
        "name":"Practical Concrete Hat",
        "price":"$26.00",
        "shortDescription":"Repellat alias delectus.",
        "description":"Perferendis et consequatur autem illum quidem quae asperiores atque. Odit nihil praesentium enim reprehenderit dolores velit porro. Deserunt officiis ipsam voluptatem vel expedita est aspernatur cumque porro.",
        "image":"https://picsum.photos/id/1043/500/500/",
        "category":"Electronics"
    },
    {
        "id":"3348e26f-b50f-484f-8f4a-78f9eac1c336",
        "name":"Sleek Concrete Bike",
        "price":"$106.00",
        "shortDescription":"Soluta omnis et modi molestiae aut et consequatur maiores.",
        "description":"Repellendus molestiae et vitae in et. Ipsa et dolore molestiae. Eos aut enim. Temporibus mollitia voluptatem. Sit et beatae eveniet aut. Qui ab neque non sed.",
        "image":"https://picsum.photos/id/1044/500/500/",
        "category":"Electronics"
    },
    {
        "id":"ac136f95-bbb6-460e-bd6f-403464cdf3ed",
        "name":"Small Frozen Bacon",
        "price":"$19.00",
        "shortDescription":"Exercitationem soluta vero quos omnis nesciunt.",
        "description":"Sed magnam ipsam amet pariatur inventore. Perferendis expedita nam. Voluptate nihil aut mollitia sit porro excepturi. Totam in adipisci ut autem distinctio sed laboriosam consequatur dolore. Aut possimus odit ea iusto maxime totam sed excepturi magni. Natus provident recusandae laboriosam praesentium dolores eligendi voluptatem iste.",
        "image":"https://picsum.photos/id/1045/500/500/",
        "category":"Baby"
    },
    {
        "id":"4bf01d6f-ecd7-409b-8a0e-972d72463267",
        "name":"Fantastic Rubber Cheese",
        "price":"$102.00",
        "shortDescription":"Officiis culpa voluptatem voluptas explicabo tempora aut maxime perspiciatis velit.",
        "description":"Laudantium enim veritatis autem dolorem dicta id. Fuga beatae eos doloremque rerum excepturi sint sequi. Perspiciatis qui qui. Omnis illo voluptatem praesentium omnis magnam sequi porro.",
        "image":"https://picsum.photos/id/1047/500/500/",
        "category":"Baby"
    },
    {
        "id":"ef389a79-bf71-4460-82e8-31700b2d6dbe",
        "name":"Intelligent Concrete Computer",
        "price":"$173.00",
        "shortDescription":"Ab cumque sint ad corporis expedita ipsam nam facere tempore.",
        "description":"Sapiente reprehenderit ipsum est quibusdam placeat laboriosam. Ad tenetur alias quia magni reprehenderit ut. Totam ullam qui fugit est rerum minus. Temporibus similique facilis repellendus qui sed deserunt iusto id. Dolores nam in. Architecto aperiam totam quia ab deserunt id quibusdam.",
        "image":"https://picsum.photos/id/1048/500/500/",
        "category":"Industrial"
    },
    {
        "id":"b423b093-12d5-4343-869b-89dfd8b17486",
        "name":"Fantastic Granite Soap",
        "price":"$208.00",
        "shortDescription":"Architecto magni aut suscipit qui quaerat.",
        "description":"Voluptatum qui eveniet vero. Aut quasi eius consequatur veritatis officia. Molestias nemo ipsam deserunt maxime laborum. Ab voluptatem excepturi dignissimos aliquam nam eos ut soluta quibusdam. Rerum repudiandae aut est.",
        "image":"https://picsum.photos/id/1049/500/500/",
        "category":"Games"
    },
    {
        "id":"89d544ff-c6ff-476f-87e2-00858326d6b6",
        "name":"Intelligent Fresh Soap",
        "price":"$43.00",
        "shortDescription":"Accusantium autem odit dolorem non.",
        "description":"Ut eum alias possimus optio fugiat tempora harum est odit. Dignissimos non et dolores corporis perspiciatis nihil et est. Et est quam autem itaque blanditiis et nisi. Incidunt ratione minima minus et qui quod et et eum. Eius dignissimos rerum nesciunt. Odio et est incidunt recusandae itaque.",
        "image":"https://picsum.photos/id/1050/500/500/",
        "category":"Music"
    },
    {
        "id":"7d4f4942-67b8-4a4c-bbaf-a44418f2e0a8",
        "name":"Incredible Granite Shirt",
        "price":"$303.00",
        "shortDescription":"Quidem impedit sit dolores a rerum delectus.",
        "description":"Temporibus quo est sit et reiciendis optio. Quidem voluptatibus ex omnis dolore qui assumenda. Dolor animi omnis doloremque quas et consequatur eum nostrum dolore.",
        "image":"https://picsum.photos/id/1051/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"28e6b75e-865a-457b-9fd6-9d3a5ce2e0be",
        "name":"Unbranded Steel Soap",
        "price":"$383.00",
        "shortDescription":"Debitis delectus minus mollitia ipsa dolor delectus.",
        "description":"Reiciendis aspernatur eaque numquam ut. Fugiat et nulla ut in accusantium doloribus quia. Id soluta omnis labore officiis ipsa fugiat id. Et facilis vel aut itaque quis qui odio accusamus quam. Fugiat autem eligendi quasi optio omnis enim itaque ea pariatur.",
        "image":"https://picsum.photos/id/1052/500/500/",
        "category":"Sports"
    },
    {
        "id":"dd5eb3b5-2ec9-49eb-9ae0-e5e99d3b4d3c",
        "name":"Intelligent Wooden Car",
        "price":"$365.00",
        "shortDescription":"Pariatur dolorem sint qui veniam quidem quia.",
        "description":"Aut deserunt inventore nostrum dolor. Tenetur quas tempora atque.",
        "image":"https://picsum.photos/id/1053/500/500/",
        "category":"Health"
    },
    {
        "id":"18398dcb-299b-469b-b386-f3efca3fe738",
        "name":"Fantastic Wooden Table",
        "price":"$131.00",
        "shortDescription":"Qui maxime ut eaque est alias beatae.",
        "description":"Ipsa qui aut ducimus et quia. Porro dicta maxime dolore. At magni molestiae. Aut aut assumenda voluptas error eveniet vel. Aut reprehenderit sed eius odit veniam eos dolore sed porro. Consequatur soluta iusto et perferendis aliquam quaerat.",
        "image":"https://picsum.photos/id/1054/500/500/",
        "category":"Movies"
    },
    {
        "id":"5d1e4398-8053-4747-ae8b-dcc4f39371d0",
        "name":"Small Fresh Chips",
        "price":"$260.00",
        "shortDescription":"Et sint optio ut sunt hic aperiam aut qui.",
        "description":"Dicta nisi aut aut fugiat saepe soluta deleniti aut doloribus. Repellendus id ipsum aut. Doloremque possimus est incidunt eligendi quia perspiciatis quo.",
        "image":"https://picsum.photos/id/1055/500/500/",
        "category":"Computers"
    },
    {
        "id":"c9756051-325c-4cf9-96d9-164568ca5251",
        "name":"Fantastic Wooden Keyboard",
        "price":"$332.00",
        "shortDescription":"Culpa esse odit ipsa ipsa voluptatem.",
        "description":"Molestiae voluptate corrupti eaque et quisquam asperiores asperiores et. Vitae dolore reprehenderit ut molestiae odio rem tempore qui.",
        "image":"https://picsum.photos/id/1056/500/500/",
        "category":"Kids"
    },
    {
        "id":"084a7544-d40c-41d9-bba4-278c8fbd6871",
        "name":"Practical Rubber Bacon",
        "price":"$69.00",
        "shortDescription":"Molestiae alias officiis culpa.",
        "description":"Dicta dolores praesentium exercitationem mollitia ab. Sunt sequi aut ut minima distinctio velit corporis. Et ipsam fugit facilis ullam et nobis eius molestias.",
        "image":"https://picsum.photos/id/1057/500/500/",
        "category":"Movies"
    },
    {
        "id":"9b5f7b7f-6b40-4bab-a03a-e4d5c344f31e",
        "name":"Small Metal Computer",
        "price":"$274.00",
        "shortDescription":"Provident expedita qui nam.",
        "description":"Id assumenda ipsum voluptatibus numquam eaque tempore ut quis. A quae qui aperiam dolore. Ad officia consequatur eos corporis. Et non fugiat corrupti est totam similique odit.",
        "image":"https://picsum.photos/id/1058/500/500/",
        "category":"Home"
    },
    {
        "id":"9b6520d2-33dc-4faf-abe5-d891f3634fea",
        "name":"Practical Soft Hat",
        "price":"$380.00",
        "shortDescription":"Ut sed sapiente qui sunt vitae repellat.",
        "description":"Quis aperiam est fugit corporis animi ea et corporis. Delectus qui qui quisquam similique voluptatibus voluptas cum quo harum.",
        "image":"https://picsum.photos/id/1059/500/500/",
        "category":"Baby"
    },
    {
        "id":"a9b82343-a80f-4f93-947d-3d752ed97a92",
        "name":"Gorgeous Plastic Fish",
        "price":"$128.00",
        "shortDescription":"Aut incidunt voluptas rerum alias cupiditate doloremque minima consequuntur tempora.",
        "description":"Sit non dolorem repellat dolores. Voluptatem voluptates dicta animi quo provident. Esse neque qui at ex laboriosam sint.",
        "image":"https://picsum.photos/id/106/500/500/",
        "category":"Games"
    },
    {
        "id":"b3b8a20c-32db-44c0-9994-a00c7144f497",
        "name":"Practical Soft Pants",
        "price":"$124.00",
        "shortDescription":"Enim facilis tenetur dolores non enim qui qui.",
        "description":"Corporis qui dolores nihil. Esse qui aperiam sunt ad illo numquam voluptas est. Et harum nemo et unde minus reprehenderit sint. Reiciendis aut ab et est in ut.",
        "image":"https://picsum.photos/id/1060/500/500/",
        "category":"Books"
    },
    {
        "id":"cace5d27-50e9-479b-bc89-f438ec3321d8",
        "name":"Ergonomic Fresh Fish",
        "price":"$212.00",
        "shortDescription":"Distinctio neque exercitationem nisi sequi.",
        "description":"Eius repudiandae sunt molestias quia qui enim. Doloribus vel dolore non autem quas. Occaecati itaque libero perferendis et quidem et nulla.",
        "image":"https://picsum.photos/id/1061/500/500/",
        "category":"Home"
    },
    {
        "id":"259e353a-c4d8-4e04-9336-9d4eeb6230b1",
        "name":"Rustic Fresh Hat",
        "price":"$267.00",
        "shortDescription":"Eveniet ducimus quos eum deleniti a excepturi.",
        "description":"Dolorem enim consequatur laudantium. Ea qui dignissimos eaque rerum.",
        "image":"https://picsum.photos/id/1062/500/500/",
        "category":"Home"
    },
    {
        "id":"a6e559a4-777f-4fbc-952f-a34993249643",
        "name":"Fantastic Plastic Salad",
        "price":"$59.00",
        "shortDescription":"Recusandae in quisquam ratione recusandae at aut consequatur ut.",
        "description":"Illum modi molestias accusamus tenetur. Quo dolor iusto delectus qui eligendi quaerat corrupti sapiente qui.",
        "image":"https://picsum.photos/id/1063/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"62327917-0a5a-40c2-9831-11dd05948f51",
        "name":"Unbranded Fresh Shirt",
        "price":"$201.00",
        "shortDescription":"Est sed esse ut modi sit voluptatum temporibus facilis aut.",
        "description":"Commodi et repellat rerum ratione est fugit. Ab et repellendus adipisci. Id veritatis qui eaque in sit. Tempora saepe asperiores dolor ut animi error eum rerum perferendis. Aut sunt non qui architecto eaque quae.",
        "image":"https://picsum.photos/id/1064/500/500/",
        "category":"Home"
    },
    {
        "id":"8ed30d58-d73c-4482-ad47-6a877f8ba14d",
        "name":"Unbranded Soft Soap",
        "price":"$175.00",
        "shortDescription":"Provident commodi non sint voluptate et quam repellendus at eos.",
        "description":"Porro dolorum voluptatibus. Rerum voluptas eaque sed. Aut accusantium quaerat reprehenderit error dicta nesciunt. Omnis quo possimus odit labore tempora quo voluptatem. Non impedit harum iste inventore dolore.",
        "image":"https://picsum.photos/id/1065/500/500/",
        "category":"Electronics"
    },
    {
        "id":"e73a260e-2261-4501-95f1-517f213f25e5",
        "name":"Generic Concrete Pants",
        "price":"$177.00",
        "shortDescription":"Sequi quam facilis provident numquam aut at facilis velit molestias.",
        "description":"Fugit molestiae officiis modi pariatur iste. Velit voluptas sequi quibusdam et quis ullam asperiores quia praesentium. Facilis aliquid et ex nostrum quia quis consequuntur. Veniam sed est voluptates dolorem. Sapiente iusto aut repudiandae explicabo animi sed hic voluptatum soluta.",
        "image":"https://picsum.photos/id/1066/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"97fb9ff3-e580-4979-abc3-dd551cf095d0",
        "name":"Handmade Plastic Table",
        "price":"$293.00",
        "shortDescription":"Iste quia aliquam laborum aspernatur voluptas dolores voluptatum eos quia.",
        "description":"Sapiente illo doloremque dolores voluptatibus eos quas. Assumenda deserunt aut officia. Fugit debitis culpa.",
        "image":"https://picsum.photos/id/1067/500/500/",
        "category":"Industrial"
    }
]

let productList3 = [
    {
        "id":"a0234578-1fa8-4996-87f7-12780341246f",
        "name":"Unbranded Wooden Soap",
        "price":"$358.00",
        "shortDescription":"Illum quibusdam repellat quia labore.",
        "description":"Illo quidem expedita ipsa et rerum aut quod aperiam facilis. Omnis quam et et inventore enim praesentium dolorem asperiores. Quibusdam sit est consequatur quis nemo. Ipsam consectetur quo consequatur autem officiis ut sunt. Earum neque quibusdam velit aut unde.",
        "image":"https://picsum.photos/id/1068/500/500/",
        "category":"Movies"
    },
    {
        "id":"70c9853a-e30a-46d1-912d-c3126aaccd0e",
        "name":"Intelligent Cotton Mouse",
        "price":"$175.00",
        "shortDescription":"Sed aut doloremque adipisci et ipsam repellat illo.",
        "description":"Quasi adipisci ipsa dolor ratione. Unde temporibus aut.",
        "image":"https://picsum.photos/id/1069/500/500/",
        "category":"Industrial"
    },
    {
        "id":"1342786d-b53c-4fd5-8d43-aa96e252d3ec",
        "name":"Ergonomic Steel Sausages",
        "price":"$39.00",
        "shortDescription":"Ut quibusdam qui est ut in eos corporis consequatur.",
        "description":"Aut est molestias et. Doloremque voluptas fuga ullam magni. Non quisquam aut. Doloremque eligendi sed harum pariatur porro ut nisi beatae aliquam.",
        "image":"https://picsum.photos/id/107/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"64c3104b-41f2-414c-b4d7-125e048de16d",
        "name":"Handmade Steel Chips",
        "price":"$15.00",
        "shortDescription":"Et minus ipsam quam velit dolores cumque.",
        "description":"Architecto et dignissimos qui doloremque ea iure aperiam. Dignissimos rerum eaque doloribus rerum ullam voluptatem non eos magni. Repellat soluta eos voluptatem.",
        "image":"https://picsum.photos/id/1070/500/500/",
        "category":"Grocery"
    },
    {
        "id":"a310c832-349a-4ec8-9960-2ecde69d6b61",
        "name":"Practical Metal Pants",
        "price":"$328.00",
        "shortDescription":"Ex voluptas deserunt voluptatibus.",
        "description":"Nobis amet non excepturi facilis. Et est aut et blanditiis blanditiis voluptatem. Ut quis quia sint qui numquam corrupti natus. Nisi velit ipsum voluptatem nihil sit ut repudiandae possimus. Architecto eum sed et est et et modi veritatis. Necessitatibus velit a perspiciatis eligendi eum sed odio laudantium.",
        "image":"https://picsum.photos/id/1071/500/500/",
        "category":"Outdoors"
    },
    {
        "id":"0059729d-54e4-44d5-b74d-e6cce964930d",
        "name":"Generic Granite Chair",
        "price":"$218.00",
        "shortDescription":"Assumenda exercitationem inventore sit magnam impedit architecto.",
        "description":"Nesciunt quaerat ut voluptatum fugiat explicabo. Quibusdam qui ipsam reprehenderit rerum quia. Sit saepe accusamus explicabo ut assumenda voluptatem hic assumenda. Architecto autem earum ipsa accusamus cupiditate ut et autem. Vitae est minus et est quisquam cum ea aut. Fuga alias nobis et omnis adipisci.",
        "image":"https://picsum.photos/id/1072/500/500/",
        "category":"Home"
    },
    {
        "id":"6bec405c-b25b-4772-b532-561a1767a2e0",
        "name":"Unbranded Plastic Chips",
        "price":"$197.00",
        "shortDescription":"Aliquam voluptatem aut fugiat.",
        "description":"Similique laborum sapiente iure quaerat consequatur. Veniam blanditiis a ea laborum. Officia corporis nostrum error. Harum velit id quia fuga itaque deleniti sed est adipisci. Rerum consequatur provident omnis qui aut dolorem minima vel fuga.",
        "image":"https://picsum.photos/id/1073/500/500/",
        "category":"Clothing"
    },
    {
        "id":"828568ff-8ad6-4999-baad-8af44a014e8a",
        "name":"Small Soft Computer",
        "price":"$311.00",
        "shortDescription":"Eum molestiae qui provident et ea quos iste sequi est.",
        "description":"Neque laboriosam molestiae sunt et inventore quae nulla nam. Mollitia ea eaque est. Delectus culpa et quidem omnis rerum dolor sed.",
        "image":"https://picsum.photos/id/1074/500/500/",
        "category":"Kids"
    },
    {
        "id":"6fff539b-7ab3-4945-b939-5d56506daea0",
        "name":"Licensed Steel Sausages",
        "price":"$193.00",
        "shortDescription":"Ea commodi saepe et nobis ipsa amet omnis mollitia.",
        "description":"Ipsam ipsam reiciendis necessitatibus rerum voluptatem distinctio corporis quasi nihil. Autem cupiditate odit. Quo enim laudantium et.",
        "image":"https://picsum.photos/id/1075/500/500/",
        "category":"Kids"
    },
    {
        "id":"93c4a5e0-cefa-4dd6-abf3-dbe28f3ec499",
        "name":"Refined Cotton Ball",
        "price":"$229.00",
        "shortDescription":"Nostrum adipisci aspernatur eos eos qui.",
        "description":"Voluptatem optio vel qui blanditiis ipsam eos et laudantium repellendus. Sed molestias porro velit iusto. Quia illum ut iusto non quasi in quasi eius. Cum autem quidem officiis et quasi facilis possimus iusto ducimus. Consequatur reprehenderit voluptas consequuntur placeat autem. Minima illum nam omnis vel quos sit non dolor quas.",
        "image":"https://picsum.photos/id/1076/500/500/",
        "category":"Toys"
    },
    {
        "id":"98cfbea8-0f11-4517-863f-5fcd9946f83d",
        "name":"Intelligent Concrete Sausages",
        "price":"$360.00",
        "shortDescription":"Eligendi ut ut facere doloremque rerum exercitationem totam.",
        "description":"Quas molestiae dolorum et quasi. Eos reprehenderit eaque est libero et sed.",
        "image":"https://picsum.photos/id/1077/500/500/",
        "category":"Beauty"
    },
    {
        "id":"51ec079b-fda0-476a-b5be-f870eed5c2dc",
        "name":"Incredible Wooden Gloves",
        "price":"$201.00",
        "shortDescription":"Et laborum dolorum adipisci aut.",
        "description":"Placeat non quibusdam maiores debitis laboriosam et neque et. Sunt ea laudantium omnis incidunt inventore aut quam quasi aut. Aperiam quas quia sequi a aut libero deserunt ducimus.",
        "image":"https://picsum.photos/id/1078/500/500/",
        "category":"Kids"
    },
    {
        "id":"1a2cde35-97c6-47e8-a03c-30659aa0f0e6",
        "name":"Incredible Plastic Fish",
        "price":"$177.00",
        "shortDescription":"Recusandae labore facilis.",
        "description":"Ipsum quos sit quia. Odit nam sunt ut.",
        "image":"https://picsum.photos/id/1079/500/500/",
        "category":"Outdoors"
    },
    {
        "id":"dcd80fce-7c6d-48fe-ad15-baef0106f6c6",
        "name":"Fantastic Fresh Shoes",
        "price":"$113.00",
        "shortDescription":"In repellendus aut.",
        "description":"Quo fugit voluptas quod aut ullam nihil. Enim deserunt ad hic fuga modi. Aut eligendi sit consequuntur. Aut quos occaecati officia quam repudiandae corporis fugit. Quidem possimus deleniti rerum molestias velit aut quis minima fugit. Doloribus voluptas minus.",
        "image":"https://picsum.photos/id/108/500/500/",
        "category":"Industrial"
    },
    {
        "id":"916f281e-4e40-44e0-b439-ba8c18fa28fd",
        "name":"Intelligent Metal Chair",
        "price":"$56.00",
        "shortDescription":"Unde accusamus hic nesciunt quos.",
        "description":"Consequatur quia tempora nihil error voluptatibus odit dolor ratione ducimus. Nihil a distinctio. Doloremque voluptatum corporis reiciendis ex tenetur et cupiditate. Ea dolores qui quis velit quae libero eos et accusantium. A impedit qui quo praesentium assumenda qui voluptatem.",
        "image":"https://picsum.photos/id/1080/500/500/",
        "category":"Baby"
    },
    {
        "id":"f909b5c4-8bb7-4d15-a142-07280dc17a92",
        "name":"Practical Wooden Shoes",
        "price":"$212.00",
        "shortDescription":"Modi dolores nemo.",
        "description":"Quod ipsa corrupti facere nemo nobis aspernatur eius sint. Facere cum voluptatem maxime adipisci error repellendus dolore dolor. Harum aliquam neque animi voluptatibus nulla enim voluptatibus aut aut. Eum hic totam ipsam veniam.",
        "image":"https://picsum.photos/id/1081/500/500/",
        "category":"Clothing"
    },
    {
        "id":"b328bf89-39ee-4020-994f-cbbb9faa49d4",
        "name":"Refined Plastic Pizza",
        "price":"$375.00",
        "shortDescription":"Quas qui qui adipisci.",
        "description":"Tempora cupiditate dolores atque. Commodi expedita natus omnis et. Sit eligendi aperiam. Placeat aut voluptatem alias quos assumenda aut facere.",
        "image":"https://picsum.photos/id/1082/500/500/",
        "category":"Health"
    },
    {
        "id":"c0d8d9cc-2793-4c7d-b517-d9faaaff528b",
        "name":"Small Plastic Sausages",
        "price":"$273.00",
        "shortDescription":"Recusandae autem consequatur dolor.",
        "description":"Quo aspernatur non aut inventore recusandae nihil odit excepturi et. Ipsam accusantium consectetur ab odit iste quas placeat asperiores. Reiciendis error eius consequatur esse id nulla velit quisquam. Esse quis saepe. Quidem neque dolorem.",
        "image":"https://picsum.photos/id/1083/500/500/",
        "category":"Sports"
    },
    {
        "id":"68958c4b-f663-4da9-b3da-b746aac06602",
        "name":"Awesome Granite Bike",
        "price":"$276.00",
        "shortDescription":"Officiis quo eveniet similique cumque ullam iusto velit pariatur.",
        "description":"Optio dolores illo in perspiciatis voluptatem eum sint voluptatem corporis. Et et eum.",
        "image":"https://picsum.photos/id/1084/500/500/",
        "category":"Home"
    },
    {
        "id":"ffc133f7-fcaa-4168-a21f-bbd04b83e8e8",
        "name":"Ergonomic Rubber Pizza",
        "price":"$118.00",
        "shortDescription":"Harum minus porro dolore voluptas neque aspernatur asperiores praesentium.",
        "description":"Dolorem quia nisi est iure velit magni vero quia optio. Quas cumque laboriosam sunt nam tempore et provident. Debitis asperiores sed. Pariatur quia commodi quis eaque blanditiis sunt repudiandae. Dolorum iusto voluptatem. In quasi tempore excepturi recusandae.",
        "image":"https://picsum.photos/id/109/500/500/",
        "category":"Electronics"
    },
    {
        "id":"5eb90e3f-de89-4872-9609-f1983aab010a",
        "name":"Small Plastic Cheese",
        "price":"$183.00",
        "shortDescription":"Voluptatem omnis repudiandae et libero maiores necessitatibus.",
        "description":"Quia porro temporibus nostrum. Quaerat cumque ut sunt sed quia ullam. Soluta rerum explicabo earum veritatis eos nihil.",
        "image":"https://picsum.photos/id/11/500/500/",
        "category":"Jewelery"
    },
    {
        "id":"e1597cc7-ec14-498d-a126-0fa7f107c491",
        "name":"Practical Rubber Pants",
        "price":"$350.00",
        "shortDescription":"Neque quis commodi.",
        "description":"Odio et ducimus rem voluptates facilis voluptatem. Cupiditate voluptatum quia velit ab. Perspiciatis sit odit molestiae autem laborum aspernatur sint itaque. Quis velit velit. Rem est autem sunt qui praesentium quo quia. Pariatur eum animi excepturi velit.",
        "image":"https://picsum.photos/id/110/500/500/",
        "category":"Games"
    },
    {
        "id":"16264c3b-f41b-4b91-95ee-ab3acd01ff62",
        "name":"Handmade Concrete Ball",
        "price":"$55.00",
        "shortDescription":"Error quisquam veniam et dolores.",
        "description":"Amet dolorem iure qui nemo sapiente quaerat autem hic. Eos quis expedita officia inventore ipsa est. Autem omnis sunt error aspernatur quae commodi reiciendis maxime.",
        "image":"https://picsum.photos/id/111/500/500/",
        "category":"Automotive"
    },
    {
        "id":"ec07e880-8134-439d-9f16-1e7b570b686f",
        "name":"Rustic Fresh Chicken",
        "price":"$76.00",
        "shortDescription":"Praesentium aperiam incidunt nulla itaque sed.",
        "description":"Sed aliquid et molestiae. Quae neque sit eum asperiores.",
        "image":"https://picsum.photos/id/112/500/500/",
        "category":"Outdoors"
    },
    {
        "id":"a60f3bc2-dad5-404f-a902-0d4e3c15ad50",
        "name":"Tasty Plastic Gloves",
        "price":"$202.00",
        "shortDescription":"Quisquam et impedit deserunt voluptatum.",
        "description":"Aut minima laborum ex quia sit dolores. Nulla et est et numquam aspernatur. Quibusdam quis officia officia distinctio sit velit molestiae. Magnam nam eum. Corrupti rem cum saepe rerum ut ut quasi. Dolor commodi quos quaerat ea.",
        "image":"https://picsum.photos/id/113/500/500/",
        "category":"Computers"
    },
    {
        "id":"bb2eddde-cd09-41ff-b7cb-3b84de324761",
        "name":"Awesome Wooden Chair",
        "price":"$52.00",
        "shortDescription":"Deleniti enim nulla non ad maxime non.",
        "description":"At omnis nobis. At qui facilis minima adipisci porro. Qui sapiente accusamus.",
        "image":"https://picsum.photos/id/114/500/500/",
        "category":"Games"
    },
    {
        "id":"ca81b7ab-82ae-4855-9d07-b69b58b20618",
        "name":"Practical Cotton Keyboard",
        "price":"$78.00",
        "shortDescription":"Sit asperiores iusto pariatur iusto consectetur placeat nulla at.",
        "description":"Illum adipisci ullam est. Tempore culpa dolorum. Quae aut ea.",
        "image":"https://picsum.photos/id/115/500/500/",
        "category":"Games"
    },
    {
        "id":"d9e9728b-4f7a-4298-bad3-92ef27e27fac",
        "name":"Rustic Wooden Towels",
        "price":"$328.00",
        "shortDescription":"Sint repellat aut magni sit aut.",
        "description":"Sequi soluta quos dolor voluptate rerum. Minima repudiandae facere qui iste non quibusdam. Animi sit porro minus minima sit. Ut praesentium ipsam quod quia.",
        "image":"https://picsum.photos/id/116/500/500/",
        "category":"Shoes"
    }
]

function getProductsForCategory(categoryId) {
    if (categoryId == 1) {
        return [...productList1]
    } else if (categoryId == 2) {
        return [...productList2]
    } else if (categoryId == 3) {
        return [...productList3]
    } else {
        return []
    }
}

export default getProductsForCategory;
